export const SESSION_LOGGING_MESSAGE_KEY = 'IframeSessionInitializationLog' as const;
export const MAX_RETRIES = 3;
